import { Navigate, useLocation, useParams } from 'react-router-dom';

/**
 * `/campaigns…` → `/schedule…`, keeping the query string.
 *
 * ⚠ THE SEARCH STRING IS NOT OPTIONAL. A merchant's bookmark is the obvious
 * reason for the redirect, but the one that breaks first is `?preview` — the
 * smoke harness's whole fixture rides in the query, and a redirect that drops it
 * lands on a page with no session and no config, which reads as the page being
 * broken rather than the redirect being lossy.
 *
 * `replace`, so Back returns to wherever the merchant came from rather than to a
 * URL that immediately redirects again.
 *
 * ⚠ Its own file because `src/routes/index.tsx` exports `router`, and a file
 * that exports both a component and a non-component breaks Fast Refresh — the
 * `react-refresh` rule's actual point, and worth honouring in the file that
 * defines the whole route tree.
 */
export function RedirectToSchedule() {
  const { search, hash } = useLocation();
  const { id } = useParams();
  return <Navigate to={{ pathname: id ? `/schedule/${id}` : '/schedule', search, hash }} replace />;
}
